module.exports = "/images/close-white-icon.svg?ac08c26f94849ed2613350d3356982ce";